export const MV_SCALES = [2.5, 5, 10, 20, 40];
export const TIME_SCALES = [12.5, 25, 50, 100];